export const OFFICIAL_SECTION_TITLES = {
    currentRoles: "Current Roles",
    customDescription: "Custom Description",
    worksFor: "Works For",
    previousExperience: "Previous Experience",
    education: "Education",
    contactCard: "Contact Card",
    bioData: "Biography",
    customFields: "Custom Fields",
    about: "About",
    politicalCommittees: "Political Committees",
    scores: "Scores",
    customImage: "Custom Image",
    districtOffices: "District Offices",
    socialMedia: "Social Media",
}
